import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

//GET
export const getAllShifts = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "shifts/get_shift",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response };
    } catch (error) {
        //
        return { error: error };
    }
};

// GET SINGLE
export const getShift = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "shifts/get_shift",
            {
                requester: getUser(),
                token: getToken(),
                shift_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const searchShift = async (name) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "shifts/search",
            {
                requester: getUser(),
                token: getToken(),
                name: name,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error };
    }
};

//POST
export const createShift = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "shifts/create",
            {
                requester: getUser(),
                token: getToken(),
                name: data.shift_name,
                check_template_id: data.check_template_id,
                account_no: data.account_no,
                account_name: data.account_name,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateShift = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "shifts/update",
            {
                requester: getUser(),
                token: getToken(),
                shift_id: data.id,
                name: data.shift_name,
                account_no: data.account_no,
                account_name: data.account_name,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteShifts = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "shifts/delete",
            {
                requester: getUser(),
                token: getToken(),
                shift_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};
